<template>
    <FormWrapper :is-loading="isLoading">
        <PageTitle title="Master Data" slot="title" link="/helpContent/Master DropDown" />
        <ValidationObserver ref="validator" >
            <FormRow>
                <div class="col-sm-4" >
                    <FormSelect label="Definition Group" :items="definitionList" item-name="Name" item-value="id"  v-model="filtering.selectedDefinition" :onChange="getMasterData" rules="required" />
                </div>
                <div class="col-sm-4">
                    <InputText v-model="filtering.name" style="width: 200px" label="Search for Records"  />
                </div>
                <div class="col-sm-4">
                    <FormButton style="margin-top: 5px" type="primary" @click="search" :rounded="true">
                        <Icon type="ios-search" />
                    </FormButton>
                </div>
            </FormRow>
        </ValidationObserver>
        <DataTable :actions="true"
            :data="masterDataList"
            :columns="tableConfig"
            :is-loading="isLoading"
            @on-page-change="pageChange"
            @on-selection-change="selectChange"
            :pagination="pagination"
            @on-sort-change="sortChange">
            <template slot="actionsLeft">
                <TableButton @click="() => add()">
                    <img :src="require(`Assets/images/plus-1.png`)"/>
                  Add
                </TableButton>
                <TableButton @click="() => edit()">
                    <img :src="require(`Assets/images/edit-1.png`)"/>
                  Edit
                </TableButton>
            </template>
        </DataTable>
    </FormWrapper>
</template> 

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import DataTable from 'Components/DataTable';
    import loadingMixin from 'Mixins/loadingMixin';
    import {getAllParentDefinition, getDatabyParent} from '../api';
    import tableConfig from './table';
    import validateSelectedRows from "Mixins/validateSelectedRows";
    import { ValidationObserver } from 'vee-validate';
    export default {
        name: "List",
        mixins: [loadingMixin, validateSelectedRows], 
        components: {
            FormWrapper,
            DataTable,
            PageTitle,
            ValidationObserver
        },
        data() {
            return {
                filtering: {
                    selectedDefinition: null,
                    name: ''
                },
                sorting: {
                    key: 'Name',
                    order: 'asc'
                },
                pagination: {
                    perPage: 10,
                    page: 1,
                    total: 0
                },
                tableConfig,
                masterDataList: [],
                definitionList: [],
                selectedRows: []
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getAllList()
        },
        methods: {
            add(){
                this.$router.push({ path: `/addUpdateDefinitionGroup` });
            },
            edit(){
                if (this.validateSelectedLength(1)) {
                    this.$router.push({ path: `/addUpdateDefinitionGroup/${btoa(this.selectedRows[0].id)}` });
                }
            },
            selectChange(data) {
                this.selectedRows = data;
            },
            search(){
                this.pagination.page = 1;
                this.getDataByFilter(this.filtering.selectedDefinition)
            },
            sortChange(data) {
                this.sorting.key = data.key;
                this.sorting.order = data.order;
                this.getDataByFilter(this.filtering.selectedDefinition)
            },
            getDataByFilter(ele) {
                setTimeout(() => {
                    this.$refs.validator.validate().then((result) => {
                        if (result) {
                            this.showLoader();
                            const { key, order } = this.sorting;
                            const { perPage, page } = this.pagination;
                            const filters = {};
                            if (ele == undefined) {
                                this.filtering.selectedDefinition=this.userData.user_id;
                            } else{
                                this.filtering.selectedDefinition=ele;
                            }
                            if (this.filtering.selectedDefinition) {
                                filters.parentId = this.filtering.selectedDefinition;
                            }
                            if (this.filtering.name) {
                                filters.searchText = this.filtering.name;
                            }
                            const data = {
                                filterjson: {
                                    filter: [filters],
                                    sort: [{ key, order }],
                                    paging: [
                                        {
                                            startIndex: page,
                                            pageSize: perPage
                                        }
                                    ]
                                }
                            };
                            getDatabyParent(data)
                                .then(this.handleResponse)
                                .catch(this.handleError)
                        }
                    })
                },
                50
                )
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getDataByFilter(this.filtering.selectedDefinition)
            },
            handleResponse(response) {
                this.hideLoader();
                this.masterDataList = response.data;
                this.pagination.total = response.NumberOfRecords;
            },
            async getAllList() {
                await getAllParentDefinition().then((res)=>{
                    this.definitionList=res.data;
                })
            },
            getMasterData(ele){
                this.getDataByFilter(ele)
            },
        }
    }
</script>

<style lang="scss" module>
    .pagination {
        margin: 10px 0 0;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        line-height: 26px;
    }

    .paginationText {
        margin: 0 20px;
    }

    .paginationButton {
        cursor: pointer;
        width: 26px;
        text-align: center;
        transition: background-color .2s ease-in-out,color .2s ease-in-out, box-shadow 200ms ease
    }

    .paginationButton:hover {
        background: #57a3f3;
        color: #fff;
        &:hover {
            box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
        }
    }

    .filter {
        margin: -10px 0 10px;
    }

    .filterItem {
        display: inline-block;
        margin: 0 15px 15px 0;
    }

    .filterItemCheckbox {
        flex-basis: auto;
        align-self: flex-start;
        margin-top: 13px;
    }
</style>
